/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:55
 */
import Column from "./Column";

class EnumerationColumn extends Column {

  constructor(params) {
    super(params);
    this.init();
  }

}

export default EnumerationColumn;


// WEBPACK FOOTER //
// ./resources/assets/js/columns/EnumerationColumn.js